import tw, { styled } from 'twin.macro';
import 'styled-components/macro';

/**
 * Note: `styled.div` is used instead of `tw.div` to support the `as`
 * polymorphic prop.
 */
export const FluidContainer = styled.div(tw`
  mx-[49px]

  sm:mx-[93px]
  md:mx-[105px]
  lg:(mx-auto w-[960px])
  xl:w-[1180px]
`);
